/**
 * True when Backspace/Delete should remove the selected storey.
 * A selected shape, its vertices, a whole-building outline, and a selected PDF
 * underlay have their own map shortcuts and must win over storey removal.
 */
export const shouldHandleStoreyDeleteShortcut = (options: {
  isBuildingOutlineSelected: boolean;
  hasSelectedVertices: boolean;
  hasSelectedShape: boolean;
  /** PDF underlay is selected (`transform` / `calibrate`), not merely visible. */
  isBlueprintUnderlaySelected: boolean;
}): boolean =>
  !options.isBuildingOutlineSelected &&
  !options.hasSelectedVertices &&
  !options.hasSelectedShape &&
  !options.isBlueprintUnderlaySelected;

/**
 * The map-level Tab handler must stand down when the capture-phase building
 * shortcut already claimed the event.
 */
export const shouldHandleMapStoreyTabShortcut = (
  event: Pick<
    KeyboardEvent,
    'key' | 'metaKey' | 'ctrlKey' | 'shiftKey' | 'defaultPrevented'
  >,
): boolean =>
  event.key === 'Tab' &&
  !event.metaKey &&
  !event.ctrlKey &&
  !event.shiftKey &&
  !event.defaultPrevented;
